export default __webpack_public_path__ + "alberta-prescription-mgn.be8c33e1a740708bb8c3.svg";